<script lang="ts">
  import { ChevronRight } from "lucide-svelte"

  let { plan } = $props()

  let stats = plan.goal_status_counts
</script>

<li class="shadow mb-6 bg-white rounded">
  <a href="/plans/{plan.id}" class="block hover:bg-gray-50">
    <div class="flex justify-between items-center px-4 py-4 md:px-6">
      <div class="flex justify-start items-center w-11/12 md:w-4/12">
        <img
          class="bg-gray-100 shadow h-10 w-10 rounded-full"
          src={plan.logo_url}
          alt=""
        />
        <p class="w-full ml-2 text-lg text-black break-words">
          {plan.name}
        </p>
      </div>
      <div class="grid grid-cols-4 gap-4 w-7/12 md:inline-flex">
        <div class="flex flex-row items-center justify-between">
          <div
            class="py-1 px-3 border border-gray-200 shadow rounded-full flex bg-gray-50 items-center justify-start whitespace-nowrap"
          >
            <div class="flex-none h-4 w-4 rounded-full bg-on_track"></div>
            <p class="text-sm text-gray-900 ml-1 whitespace-nowrap">
              <span class="font-bold">{stats.on_track ?? 0}</span> On Track
            </p>
          </div>
        </div>
        <div class="flex flex-row items-center">
          <div
            class="py-1 px-3 border border-gray-200 shadow rounded-full flex bg-gray-50 items-center justify-start whitespace-nowrap"
          >
            <div class="flex-none h-4 w-4 rounded-full bg-at_risk"></div>
            <p class="text-sm text-gray-900 ml-1 whitespace-nowrap">
              <span class="font-bold">{stats.at_risk ?? 0}</span> At Risk
            </p>
          </div>
        </div>
        <div class="flex flex-row items-center">
          <div
            class="py-1 px-3 border border-gray-200 shadow rounded-full flex bg-gray-50 items-center justify-start whitespace-nowrap"
          >
            <div class="flex-none h-4 w-4 rounded-full bg-critical"></div>
            <p class="text-sm text-gray-900 ml-1 whitespace-nowrap">
              <span class="font-bold">{stats.critical ?? 0}</span> Critical
            </p>
          </div>
        </div>
        <div class="flex flex-row items-center">
          <div
            class="py-1 px-3 border border-gray-200 shadow rounded-full flex bg-gray-50 items-center justify-start whitespace-nowrap"
          >
            <div class="flex-none h-4 w-4 rounded-full bg-complete"></div>
            <p class="text-sm text-gray-900 ml-1 whitespace-nowrap">
              <span class="font-bold">{stats.complete ?? 0}</span> Complete
            </p>
          </div>
        </div>
      </div>
      <div class="flex justify-end w-1/12">
        <ChevronRight class="h-6 w-6 text-gray-400" />
      </div>
    </div>
    <div class="md:hidden p-6">
      <div class="grid grid-cols-4 gap-4">
        <div class="flex flex-row items-center justify-around">
          <div
            class="py-1 px-3 border border-gray-200 shadow rounded-full flex bg-gray-50 items-center justify-start whitespace-nowrap"
          >
            <div class="flex-none h-3 w-3 rounded-full bg-on_track"></div>
            <p class="text-xs text-gray-900 ml-1 whitespace-nowrap">
              {stats.on_track ?? 0} On Track
            </p>
          </div>
        </div>
        <div class="flex flex-row items-center">
          <div
            class="py-1 px-3 border border-gray-200 shadow rounded-full flex bg-gray-50 items-center justify-start whitespace-nowrap"
          >
            <div class="flex-none h-3 w-3 rounded-full bg-at_risk"></div>
            <p class="text-xs text-gray-900 ml-1 whitespace-nowrap">
              {stats.at_risk ?? 0} At Risk
            </p>
          </div>
        </div>
        <div class="flex flex-row items-center">
          <div
            class="py-1 px-3 border border-gray-200 shadow rounded-full flex bg-gray-50 items-center justify-start whitespace-nowrap"
          >
            <div class="flex-none h-3 w-3 rounded-full bg-critical"></div>
            <p class="text-xs text-gray-900 ml-1 whitespace-nowrap">
              {stats.critical ?? 0} Critical
            </p>
          </div>
        </div>
        <div class="flex flex-row items-center">
          <div
            class="py-1 px-3 border border-gray-200 shadow rounded-full flex bg-gray-50 items-center justify-start whitespace-nowrap"
          >
            <div class="flex-none h-3 w-3 rounded-full bg-complete"></div>
            <p class="text-xs text-gray-900 ml-1 whitespace-nowrap">
              {stats.complete ?? 0} Complete
            </p>
          </div>
        </div>
      </div>
    </div></a
  >
</li>
